import React from 'react'
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'

export default function MobileMenuItem() {
    return <Skeleton mb="2" height="30px" width="100%" />
}
